module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-backoffice-category-list reporting-types-list row column"
  }, [_c('div', {
    staticClass: "row"
  }, _vm._l((_vm.types), function(type, index) {
    return _c('div', {
      key: ("RT{type.id}-" + index),
      staticClass: "column small-12 large-6 category"
    }, [_c('div', {
      staticClass: "inner-content card text-center"
    }, [_c('div', {
      staticClass: "row text-center"
    }, [_c('div', {
      staticClass: "column text-left"
    }, [_c('h2', [_vm._v(_vm._s(type.name))])]), _c('div', {
      staticClass: "column text-right"
    }, [_c('ModalReveal', {
      ref: 'reveal-' + type.uid,
      refInFor: true
    }, [_c('i', {
      staticClass: "fa fa-pencil",
      attrs: {
        "slot": "trigger"
      },
      slot: "trigger"
    }), _c('EditReportingType', {
      attrs: {
        "reportingType": type
      },
      on: {
        "reportingTypeEdited": function($event) {
          return _vm.reportEdited(type)
        }
      }
    })], 1), _c('pre', [_vm._v("RT" + _vm._s(type.id))])], 1)]), _c('div', {
      staticClass: "row text-center"
    }, [_c('div', {
      staticClass: "column text-left"
    }, [_c('p', [_vm._v(_vm._s(type.description))])])])])])
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-60437314!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/backoffice/ReportingTypesList.vue
// module id = 2538
// module chunks = 1